import KzsTemplateApi from './kzs-template.api';

class KzsTemplateService {
  constructor() {
    this.api = new KzsTemplateApi();
  }

  /**
   *  Метод для получения списка шаблонов задач КЗС
   * @param {Object} params - Параметры запроса
   * @param {string} params.templateName - Строка поиска
   * @param {number} params.page - Номер страницы
   * @param {number} params.limit - Количество шаблонов задач КЗС на странице
   * @returns
   */
  async getKzsTemplateList(params) {
    return await this.api.getKzsTemplateList(params);
  }

  /**
   *  Метод для получения шаблона задачи КЗС по ID
   * @param {string} id - ID шаблона задачи КЗС
   * @returns
   */
  async getKzsTemplateById(id) {
    return await this.api.getKzsTemplateById(id);
  }

  /**
   *  Метод для создания шаблона задачи КЗС
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование шаблона задачи КЗС
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание шаблона задачи КЗС
   * @returns
   */
  async createKzsTemplate(params) {
    return await this.api.createKzsTemplate(params);
  }

  /**
   *  Метод для удаления шаблона задачи КЗС
   * @param {string} id - ID шаблона задачи КЗС
   * @returns
   */
  async deleteKzsTemplate(id) {
    return await this.api.deleteKzsTemplate(id);
  }

  /**
   *  Метод для обновления шаблона задачи КЗС
   * @param {string} id - ID шаблона задачи КЗС
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование шаблона задачи КЗС
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание шаблона задачи КЗС
   * @returns
   */
  async updateKzsTemplate(id, params) {
    return await this.api.updateKzsTemplate(id, params);
  }

  /**
   *  Метод для получения списка шаблонов задач КЗС
   * @returns
   */
  async getShortKzsTemplateList() {
    return await this.api.getShortKzsTemplateList();
  }
}

const kzsTemplateService = new KzsTemplateService();
export default kzsTemplateService;
